<script lang="ts">
  import { onMount } from "svelte"
  import type { Destination, JobDestination } from "../services/models"
  import { getDestinations } from "../services/endpoints"
  import { Button, Flex, FlexItem, Card, TextField, Select, SelectItem } from "@gl/design-system"
  import { _ } from "svelte-i18n"

  export let destinations: JobDestination[] = []
  export let readonly: boolean = false

  let uploadDestinations: Destination[] = []

  onMount(() => {
    getDestinations(100).then(d => uploadDestinations = d.list)
  })
</script>
<div>
  {#each destinations as destination, i }
  <Card style="padding-bottom: 1rem;">
    <Flex style="align-items: end; width: 100%;">
      <FlexItem style="flex-grow: 1;">
        <TextField label="Filename Template" required={true} bind:value={destination.filenameTemplate}/>
      </FlexItem>
      <FlexItem>
        <TextField label="Path Template" bind:value={destination.pathTemplate}/>
      </FlexItem>
      <FlexItem>
        <Select label="Destination" required={true} bind:value={destination.destinationUuid}>
          {#each uploadDestinations as uploadDestination}
            <SelectItem label={uploadDestination.name} value={uploadDestination.uuid}></SelectItem>
          {/each}
        </Select>
      </FlexItem>
      <FlexItem>
        <TextField label="File Filter" bind:value={destination.fileFilter}/>
      </FlexItem>
      {#if !readonly }
      <FlexItem style="margin-left: 1rem;">
        <Button status="error" on:click={() => {destinations.splice(i, 1); destinations = destinations}}>{$_("common.delete")}</Button>
      </FlexItem>
      {/if}
    </Flex>
  </Card>
  {/each}
  {#if !readonly }
  <Flex style="justify-content: end; margin-top: 1rem;">
    <Button on:click={() => {destinations.push({filenameTemplate: "{{ video_streams[0].height }}p.mp4", pathTemplate: "", destinationUuid: ""}); destinations = destinations}}>{$_("common.add")}</Button>
  </Flex>
  {/if}
</div>